module.exports = __webpack_public_path__ + "img/BR.c176678a.png";